import { orpc } from "@/utils/orpc.client";

export function getWorkQueryOptions(id: string, locale = "en") {
  return orpc.music.getWork.queryOptions({ input: { id, locale } });
}
